const toTitleCase = (str: string) =>
  str
    .toLowerCase()
    .split(/[\s_]+/)
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");

export const StatusCard = ({title, type}: {title: string; type: string}) => {
  return (
    <div
      className={`h-7 w-max flex items-center gap-2 rounded-[14px] px-2 ${
        type === "success"
          ? "bg-[#ECFDF3]"
          : type === "pending"
          ? "bg-[#ffeed4]"
          : type === "failed"
          ? "bg-[#fadbe1]"
          : type === "pickup"
          ? "bg-[#E9F4FF]"
          : type === "delivery"
          ? "bg-[#EBF6FF]"
          : type === "hub"
          ? "bg-[#F1EBFF]"
          : "bg-[#eceff3]"
      }`}
    >
      <div
        className={`w-[5.29px] h-[5.29px] rounded-full ${
          type === "success"
            ? "bg-[#12b76a]"
            : type === "pending"
            ? "bg-[#ff9638]"
            : type === "failed"
            ? "bg-[#df1c41]"
            : type === "pickup"
            ? "bg-[#3182CE]"
            : type === "delivery"
            ? "bg-[#0BC5EA]"
            : type === "hub"
            ? "bg-[#805AD5]"
            : "bg-[#36394a]"
        }`}
      />
      <span
        className={`text-sm font-medium ${
          type === "success"
            ? "text-[#12b76a]"
            : type === "pending"
            ? "text-[#ff9638]"
            : type === "failed"
            ? "text-[#df1c41]"
            : type === "pickup"
            ? "text-[#3182CE]"
            : type === "delivery"
            ? "text-[#0BC5EA]"
            : type === "hub"
            ? "text-[#805AD5]"
            : "text-[#36394a]"
        }`}
      >
        {toTitleCase(title)}
      </span>
    </div>
  );
};
